// config
import * as http from 'utils/http';
import config from 'config';

const acceptQuote = async ({ ticketId, quoteId }) => {
  return http.post(
    `${config.API_URL}price-negotiation/tickets/${ticketId}/quotes/${quoteId}/acceptances/`
  );
};

export default acceptQuote;
